<template>
    <div v-if="buttonInfo !== null" class="callout">
        <a
            v-if="buttonInfo.ShowCreateClaimButton"
            :href="buttonInfo.CreateClaimButtonUrl"
            class="button large secondary"
            data-test-create-claim-btn
            @click="goToCreateClaimPage(buttonInfo.ProductName.toLowerCase())"
            v-html="buttonInfo.CreateClaimButtonText"
        />
        <green-card-download-button
            v-if="isVehiclePolicy && buttonInfo.DownloadGreenCardPDFButtonText"
            :button-text="buttonInfo.DownloadGreenCardPDFButtonText"
            :policy-number="buttonInfo.PolicyNumber"
        />
        <a
            v-for="(button, index) in buttonInfo.ButtonLinkModels"
            :key="'button-l-' + index"
            :href="button.Url"
            :target="button.Target"
            data-test-link-models
            class="button large secondary"
            v-html="button.Text"
        />
        <a
            v-if="buttonInfo.ShowChangeTermPageButton"
            :href="buttonInfo.ChangeTermPageButtonUrl"
            class="button large secondary"
            data-test-payment-frequency-btn
            @click="goToChangePaymentTermPage()"
            v-html="buttonInfo.ChangeTermPageButtonText"
        />
        <a
            v-if="buttonInfo.ShowFalckRoadsideAssistanceButton"
            :href="buttonInfo.FalckRoadsideAssistanceButtonUrl"
            class="button large secondary"
            data-test-falck-roadside-assistance-btn
            target="_blank"
            v-html="buttonInfo.FalckRoadsideAssistanceButtonText"
        />
        <a 
            v-if="buttonInfo.ShowTravelCertificateDownloadButton"
            :href="buttonInfo.TravelCertificateDownloadButtonLink"
            v-html="buttonInfo.TravelCertificateDownloadButtonText"
            class="button large primary" 
            data-test-travel-certificate-btn 
        />
    </div>
</template>
<script>
import GreenCardDownloadButton from '../../GreenCardDownload/GreenCardDownloadButton.vue';
export default {
    components: {
        GreenCardDownloadButton
    },
    props: {
        buttonInfo: {
            type: Object,
            default() {
                return null;
            }
        }
    },
    computed: {
        isVehiclePolicy() {
            return this.buttonInfo.PolicyType === 'car'
                || this.buttonInfo.PolicyType === 'motorcycle'
                || this.buttonInfo.PolicyType === 'veteran';
        }
    },
    methods: {
        goToCreateClaimPage(name) {
            return this.$store.dispatch('Events/register', {
                event: `policy-section-click-create-claim-button-${name}`,
                id: 'policySection'
            });
        },
        goToChangePaymentTermPage() {
            return this.$store.dispatch('Events/register', {
                event: 'payment-term-level-two',
                id: 'paymentTerm'
            });
        },
    }
}
</script>
<style lang="scss" scoped>
@import '../../../../styles/all.scss';

.callout > .button:not(:first-child) {
    margin-top: rem-calc(15px);
}
</style>